import {ParentalLeaveFlow} from '../flow'

export const Confirm = () => <ParentalLeaveFlow />
